import { NgClass } from '@angular/common';
import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatCardContent, MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatLabel } from '@angular/material/form-field';
import { CommentService } from 'src/app/services/comment.service';
import { UserComment } from 'src/app/models/UserComment.model';
import { Page } from 'src/app/models/page.model';
import { UserFeedbackService } from 'src/app/services/userFeedback.service';
import {
    AddCommentComponent,
    DialogData,
} from '../feedback-card/add-comment/add-comment.component';
import { UserFeedback } from 'src/app/models/UserFeedback.model';
import { FEEDBACKID } from 'src/app/constants/queryParamConstants';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { UserTicketStatus } from 'src/app/enums/userTicketStatus.enum';
import { UserFeedbackStatuses } from 'src/app/interfaces/userFeedback-Form';

interface StatusForm {
    processed: FormControl<boolean>;
    duplicate: FormControl<boolean>;
}

@Component({
    selector: 'app-see-details',
    standalone: true,
    imports: [
        MatCardModule,
        MatCardContent,
        MatLabel,
        MatChipsModule,
        MatIconModule,
        NgClass,
        ReactiveFormsModule,
        MatButtonModule,
    ],
    templateUrl: './see-details.component.html',
    styleUrl: './see-details.component.scss',
    encapsulation: ViewEncapsulation.None,
})
export class SeeDetailsComponent {
    private queryParams: Map<string, string> = new Map<string, string>();
    protected readonly Status = UserTicketStatus;
    private _statusForm: FormGroup<StatusForm> = new FormGroup({
        processed: new FormControl<boolean>(false),
        duplicate: new FormControl<boolean>(false),
    });

    private _comments: Page<UserComment> = new Page<UserComment>({
        countRequested: -1,
        offsetRequested: 0,
        items: [],
        totalCount: 0,
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        protected data: {
            userView: boolean;
            selectedTicket: UserFeedback;
        },
        private commentService: CommentService,
        private userFeedbackService: UserFeedbackService,
        private dialog: MatDialog,
    ) {}

    ngOnInit(): void {
        if (this.data?.selectedTicket.status === UserTicketStatus.Processed) {
            this._statusForm.controls.processed.setValue(true);
        } else if (
            this.data?.selectedTicket.status === UserTicketStatus.Duplicate
        ) {
            this._statusForm.controls.duplicate.setValue(true);
        }

        this.fetchComments();
    }

    get comments(): Page<UserComment> {
        return this._comments;
    }

    get statusForm(): FormGroup<StatusForm> {
        return this._statusForm;
    }

    protected addComment(): void {
        const dialog = this.dialog.open<
            AddCommentComponent,
            DialogData,
            boolean
        >(AddCommentComponent, {
            disableClose: true,
            width: '25%',
            height: '35%',
            data: { feedbackId: this.data?.selectedTicket.id },
        });

        dialog.afterClosed().subscribe((result) => {
            if (result) {
                this.fetchComments();
            }
        });
    }

    protected onCheckboxChange(status: UserFeedbackStatuses): void {
        if (status === UserTicketStatus.Processed) {
            this._statusForm.controls['duplicate'].setValue(false);
        } else if (status === UserTicketStatus.Duplicate) {
            this._statusForm.controls['processed'].setValue(false);
        }

        if (
            !this._statusForm.controls.processed.value &&
            !this._statusForm.controls.duplicate.value
        ) {
            status = UserTicketStatus.Read;
        }

        this.data.selectedTicket.status = status;

        this.userFeedbackService
            .put([this.data?.selectedTicket.id], this.data?.selectedTicket)
            .subscribe();
    }

    private fetchComments(): void {
        this.queryParams.set(FEEDBACKID, this.data?.selectedTicket.id);

        this.commentService
            .get([], this.queryParams)
            .subscribe((response: Page<UserComment>) => {
                this._comments = response;
            });
    }
}
